import { IFeedbackResponse } from "../models/IFeedback";
import { configWithUserToken } from "./config";

export const getPendingFeedbacks = (restaurantId: string, pageIndex: number, pageSize: number) =>
  configWithUserToken.get<IFeedbackResponse>(
    `Feedback/restourant/${restaurantId}/pending?pageIndex=${pageIndex}&pageSize=${pageSize}`
  );

export const approveFeedback = (feedbackId: string) =>
  configWithUserToken.put(`Feedback/${feedbackId}/approve`);

export const deleteFeedback = (feedbackId: string) =>
  configWithUserToken.delete(`Feedback/${feedbackId}`);
